/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_RecommendedInputs */

const id_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direkomendasikan`)
};

const ms_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disyorkan`)
};

const da_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbefalet`)
};

const de_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfohlen`)
};

const en_us2_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

const es_es2_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado`)
};

const es_mx2_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado`)
};

const fil_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inirerekomenda`)
};

const fr_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommandé`)
};

const it_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consigliato`)
};

const hu_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlott`)
};

const nl_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbevolen`)
};

const no_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbefalt`)
};

const pl_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalecane`)
};

const pt_br2_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado`)
};

const pt_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado`)
};

const ro_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomandat`)
};

const fi_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suositeltu`)
};

const sv_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekommenderad`)
};

const vi_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Được đề xuất`)
};

const tr_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önerilen`)
};

const cs_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doporučeno`)
};

const bg_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Препоръчано`)
};

const ru_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуется`)
};

const uk_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендовано`)
};

const ar_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موصى به`)
};

const hi_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुशंसित`)
};

const th_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แนะนำ`)
};

const ja_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推奨`)
};

const zh_cn2_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐`)
};

const zh_hant1_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推薦`)
};

const ko_misc_downloads_recommended = /** @type {(inputs: Misc_Downloads_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`권장`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Misc_Downloads_RecommendedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_recommended = /** @type {((inputs?: Misc_Downloads_RecommendedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_RecommendedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_recommended(inputs)
	if (locale === "ms") return ms_misc_downloads_recommended(inputs)
	if (locale === "da") return da_misc_downloads_recommended(inputs)
	if (locale === "de") return de_misc_downloads_recommended(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_recommended(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_recommended(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_recommended(inputs)
	if (locale === "fil") return fil_misc_downloads_recommended(inputs)
	if (locale === "fr") return fr_misc_downloads_recommended(inputs)
	if (locale === "it") return it_misc_downloads_recommended(inputs)
	if (locale === "hu") return hu_misc_downloads_recommended(inputs)
	if (locale === "nl") return nl_misc_downloads_recommended(inputs)
	if (locale === "no") return no_misc_downloads_recommended(inputs)
	if (locale === "pl") return pl_misc_downloads_recommended(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_recommended(inputs)
	if (locale === "pt") return pt_misc_downloads_recommended(inputs)
	if (locale === "ro") return ro_misc_downloads_recommended(inputs)
	if (locale === "fi") return fi_misc_downloads_recommended(inputs)
	if (locale === "sv") return sv_misc_downloads_recommended(inputs)
	if (locale === "vi") return vi_misc_downloads_recommended(inputs)
	if (locale === "tr") return tr_misc_downloads_recommended(inputs)
	if (locale === "cs") return cs_misc_downloads_recommended(inputs)
	if (locale === "bg") return bg_misc_downloads_recommended(inputs)
	if (locale === "ru") return ru_misc_downloads_recommended(inputs)
	if (locale === "uk") return uk_misc_downloads_recommended(inputs)
	if (locale === "ar") return ar_misc_downloads_recommended(inputs)
	if (locale === "hi") return hi_misc_downloads_recommended(inputs)
	if (locale === "th") return th_misc_downloads_recommended(inputs)
	if (locale === "ja") return ja_misc_downloads_recommended(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_recommended(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_recommended(inputs)
	return ko_misc_downloads_recommended(inputs)
});
export { misc_downloads_recommended as "misc.downloads.recommended" }